import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, SurfaceColors } from '@/utils/constants';

const lightTheme = {
  root: {
    backgroundColor: SurfaceColors.light,
    '&.MuiInputBase-input': {},
  },
  inputInput: {},
};

const darkTheme = {
  root: {
    border: `1px solid ${SurfaceColors.light}`,
    backgroundColor: 'transparent',
  },
  inputInput: {
    color: SurfaceColors.light,
  },
};

const onlyIconVariant = {
  inputInput: {
    paddingLeft: '1em',
  },
};
const withLabelVariant = {
  inputInput: {
    paddingLeft: '0',
  },
};

const useSearchInputStyles = makeStyles(
  (muiTheme) => ({
    search: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '&.MuiBox-root': {
        position: 'relative',
        borderRadius: '17px',
        marginLeft: 0,
        width: '100%',

        [muiTheme.breakpoints.up('md')]: {
          width: 'auto',
          marginLeft: muiTheme.spacing(1),
          marginBottom: '4px',
        },

        [muiTheme.breakpoints.down('sm')]: {
          padding: muiTheme.spacing(2, 0),
          height: '34px',
          marginBottom: muiTheme.spacing(2),
        },
      },
    },
    searchIcon: {
      padding: muiTheme.spacing(0, 1),
      height: '100%',
      pointerEvents: 'none',
    },
    searchActionLabel: {
      padding: muiTheme.spacing(0, 2, 0, 2),
      minWidth: 'auto !important',
      borderRadius: '17px',
      height: '34px',
    },
    icon: {
      color: SecondaryColors.dark,
    },
    inputRoot: {
      '&.MuiInputBase-root': {
        color: 'inherit',
        flexGrow: 1,
      },
    },
    inputInput: {
      '&.dark-theme': darkTheme.inputInput,
      '&.light-theme': lightTheme.inputInput,
      '&.only-icon-variant': onlyIconVariant.inputInput,
      '&.with-label-variant': withLabelVariant.inputInput,
      '&.MuiInputBase-input': {
        textAlign: 'left',
        padding: muiTheme.spacing(1, 1, 1, 0),
        transition: muiTheme.transitions.create('width'),
        width: '100%',

        [muiTheme.breakpoints.up('sm')]: {
          width: '18ch',
          '&:focus': {
            width: '18ch',
          },
        },
      },
    },
  }),
  { name: 'SearchInput' },
);

export default useSearchInputStyles;
